import React from 'react';
import { Box, Grid, Typography, Button, Modal } from "@mui/material";
import Lottie from 'react-lottie';
import * as animationData from "./warningnew.json";
import './Warning.css';
import { useTranslation } from 'react-i18next';

const Warning = (props: any) => {
  const { t } = useTranslation();
 
  function cancel() {
    props.oncancel(true);
  }
  function confirm() {
    props.onconfirm(true);
  }
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  return (
    <>
      <Modal open={props?.openmodal} onClose={() => cancel()}>
        <Box className="warning-confirmModel app-modal">
          <Box style={{ display: 'flex'}}>
            <Box style={{ flex: 1 }}>
              <Lottie
                options={defaultOptions}
                height={'8.375em'}
                width={'8.375em'}
              />
              <Typography className="infocolumndate">
                <Typography display="inline" className="welcome-heading">
                  {t('Warning!')}
                </Typography>
                <Typography display="inline" className="warning-message">
                  {t(props?.title)}
                </Typography>
                <Typography display="inline" className="warning-message">
                  {t(props?.infoMessage)}
                </Typography>
              </Typography>
            </Box>
            <i
              className="las la-times"
              style={{
                fontSize: '1.5em',
                cursor: 'pointer',
                position: 'absolute',
                right: '20px',
                top: '20px',
              }}
              onClick={() => cancel()}
            ></i>
          </Box>
          <Grid container>
            <Grid item xs={12}>
              <Box className="warning-btn-box">
                <Button
                  className="warning-button-close"
                  variant="outlined"
                  onClick={() => cancel()}
                >
                  {t('CANCEL')}
                </Button>
                <Button
                  className="warning-button1"
                  onClick={() => {
                    confirm();
                  }}
                >
                  {t('CONFIRM')}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};
export default Warning;
